module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-2.f303d008.jpg";